import { sortOptionsISelect } from "../helpers/sortISelect";
import { JobFunction } from "../model/enumerations/job-function.model";
import { ISelect } from "../model/iSelect";

export const jobFunctionEnum = (): Array<ISelect> => {
  const jobFunction: Array<ISelect> = [
    {
      label: "Ventas",
      value: JobFunction.SALES,
    },
    {
      label: "Soporte Tecnico",
      value: JobFunction.TECHNICAL_SUPPORT,
    },
    {
      label: "Otra",
      value: JobFunction.OTHERS,
    },
  ];
  return sortOptionsISelect(jobFunction);
};
